import React from 'react'

const Contact = () => {
  return (
    <div name="Contact" 
    className='w-full bg-gradient-to-b from-black to-gray-800 p-4 text-white'
    >
      <div className='flex flex-col p-4 justify-center max-w-screen-lg mx-auto h-full'>
        <div className='pb-8'>
            <p className='text-4xl border-b-2 inline font-bold border-gray-500'>Contact</p>
            <p className='py-6'>Submit the form below to get in touch with me</p>
        </div>
           <div className='flex justify-center items-center'>
             <form action="https://getform.io/f/fdc6a6fe-605a-40d1-854c-1ab1b991f456" method='POST' className='flex flex-col w-full md:w-1/2'>
                <input type="text" name='name' placeholder='Enter your name'
                 className='  bg-transparent p-2 border-2 rounded-md text-white focus:outline-none '
                />
                <input type="email" name='email' placeholder='Enter your mail'
                 className=' my-4 bg-transparent p-2 border-2 rounded-md text-white focus:outline-none '
                />
                <textarea name="message"  rows="10"
                 className='bg-transparent p-2 border-2 rounded-md text-white focus:outline-none'
                 placeholder='Enter your message'
                ></textarea>
                <button 
                className='text-white  bg-gradient-to-b from-cyan-500 to-blue-500 px-6 py-3 rounded-md hover:scale-110 duration-300 my-8 mx-auto flex items-center'>lets talk</button>
             </form>
           </div>
      </div>
    </div>
  )
}

export default Contact
